import { mainColors, riskChannelsColors, semanticColors } from '../../styles/colors'

export const getAvatarInitials = (name: string) =>
  name
    .split(' ', 2)
    .map(n => n[0])
    .join('')
    .toUpperCase()

export const getAvantarColor = (name: string) => {
  const colorsList = [
    riskChannelsColors.channelAirbnb,
    riskChannelsColors.channelFrontdesk,
    riskChannelsColors.channelPersona,
    mainColors.accentMedium,
    riskChannelsColors.channelWebsite,
    semanticColors.successMedium,
    semanticColors.warningMedium,
    riskChannelsColors.channelExpedia,
  ]
  let hash = 0
  for (let i = 0; i < name.length; i += 1) {
    hash += name.charCodeAt(i)
  }
  return colorsList[hash % 8]
}
